const TYPE_DEFAULTS = {
    boolean: false,
    number:  '',
    array:   [],
    date:    null,
};

function getTypeDefault(type) {
    return TYPE_DEFAULTS[type] ?? '';
}

export function buildInitialValues(fields, record = null) {
    return Object.fromEntries(
        fields
            .filter(f => f.showInForm)
            .map(field => {
                const recordVal = record?.[field.name];
                const val = recordVal !== undefined && recordVal !== null
                    ? recordVal
                    : field.defaultValue ?? getTypeDefault(field.type);
                return [field.name, val];
            })
    );
}
